const fitsWithinTwoLines = (widths: number[], containerWidth: number) => {
  let lineCount = 1;
  let lineWidth = 0;

  for (const width of widths) {
    if (lineWidth > 0 && lineWidth + width > containerWidth) {
      lineCount += 1;
      lineWidth = width;
    } else {
      lineWidth += width;
    }
  }

  return lineCount <= 2;
};

export const fitVisibleTopicCount = ({
  containerWidth,
  topicWidths,
  separatorWidth,
  overflowWidths,
}: {
  containerWidth: number;
  topicWidths: number[];
  separatorWidth: number;
  overflowWidths: number[];
}) => {
  if (containerWidth <= 0 || topicWidths.length <= 1) {
    return topicWidths.length;
  }

  for (let count = topicWidths.length; count >= 1; count -= 1) {
    const hiddenCount = topicWidths.length - count;
    const widths = topicWidths
      .slice(0, count)
      .map((width, index) => width + (index < count - 1 ? separatorWidth : 0));

    if (hiddenCount > 0) {
      widths.push(overflowWidths[hiddenCount - 1] ?? 0);
    }

    if (fitsWithinTwoLines(widths, containerWidth)) {
      return count;
    }
  }

  return 1;
};
